/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const schemeLocationChangeImpactRequestSchema = z.object({
  isDefault: z.boolean().nullish(),
  locationIds: z.array(z.int()),
  schemeId: z.int().nullish(),
  type: z.enum(['HOLIDAY', 'WORKLOAD']),
});
